<template>
  <a-card :bordered="false" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row slot="title">
      <a-col :span="24" style="cursor: pointer;">
        <span @click="goBack">手动匹配</span>
        <!--        <span @click="goBack">手动匹配</span>>{{proName}}(产品ID:{{proId}})-->
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="10">
        <div class="title-name">{{ proName }}( 产品ID:{{ proId }}) 匹配信息</div>
        <ul class="ul-content" v-if="erpHotelInfo">
          <li><span class="left-labei">所在城市：</span><span class="right-content">{{ erpHotelInfo.cityName }}</span>
          </li>
          <li><span class="left-labei">名称：</span><span class="right-content">{{ erpHotelInfo.hotelName }}</span></li>
          <li><span class="left-labei">电话：</span><span class="right-content">{{ erpHotelInfo.hotelPhone }}</span></li>
          <li><span class="left-labei">地址：</span><span class="right-content">{{ erpHotelInfo.hotelAddress }}</span>
          </li>
          <li><span class="left-labei">经纬度：</span><span
            class="right-content">{{ erpHotelInfo.longitude }}/{{ erpHotelInfo.latitude }}</span></li>
        </ul>
      </a-col>
      <a-col :span="14">
        <div class="title-name">推荐的可匹配酒店</div>
        <a-form-model layout="inline" style="margin-bottom: 15px;">
          <a-form-model-item>
            <a-input v-model="queryParams.hotelId" placeholder="请输入商品ID"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-input v-model="queryParams.hotelName" placeholder="请输入商品名称/关键词"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="search-list">
          <div class="recommend-name">已匹配的酒店</div>
          <a-table
            :columns="getProColumns()"
            rowKey="hotelId"
            :dataSource="searchDataList" :pagination="false"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}">
            <template slot="latSlots" slot-scope="text, record">
              <div>经:{{ record.longitude }}</div>
              <div>纬:{{ record.latitude }}</div>
            </template>
          </a-table>
          <div class="recommend-name" style="margin-top: 20px;">搜索酒店列表</div>
          <custom-page-table
            ref="table"
            rowKey="hotelId"
            :columns="getProColumns()"
            :enableSearch="false"
            :queryParams="queryParams"
            :requestPromise="loadPromise"
            :rowSelection="{ selectedRowKeys: searchRowKeys, onChange: onSearchChange,getCheckboxProps:onCheckboxProps }"
          >
            <template slot="latSlots" slot-scope="data">
              <div>经:{{ data.record.longitude }}</div>
              <div>纬:{{ data.record.latitude }}</div>
            </template>
          </custom-page-table>
        </div>
        <div class="btns">
          <a-button type="primary" :loading="loading" @click="onSubmitData">提交</a-button>
          <a-button @click="goBack">返回</a-button>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
export default {
  name: 'HotelhandleMatch',
  data() {
    return {
      proName: this.$route.query.proName,
      proId: this.$route.query.proId,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      queryParams: {
        hotelId: '',
        hotelName: '',
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      erpHotelInfo: '',
      selectedRowKeys: [],
      searchRowKeys: [],
      searchDataList: [],
      loading: false
    }
  },
  mounted() {
  },
  activated() {
    this.proId = this.$route.query.proId
    this.proName = this.$route.query.proName
    this.getDetailList()
    this.searchBtn()
  },
  deactivated() {
    this.resetData()
  },
  methods: {
    resetData() {
      this.erpHotelInfo = ''
      this.selectedRowKeys = []
      this.searchRowKeys = []
      this.searchDataList = []
      this.queryParams.hotelId = ''
      this.queryParams.hotelName = ''
    },
    // 获取表格数据接口
    getDetailList() {
      let params = {
        erpHotelId: this.proId,
        merchantId: this.merchantId,
        platformId: this.platformId,
        searchOption: false
      }
      this.getHttpServices().getCloudProService().post('erp/search/findErpHotelMatchDetails', params).then(res => {
        if (res.erpHotelInfo) {
          this.erpHotelInfo = res.erpHotelInfo
        }
        if (res.matchHotelInfo && res.matchHotelInfo.length > 0) {
          this.searchDataList = res.matchHotelInfo
          this.selectedRowKeys = res.matchHotelInfo.map(item => {
            return item.hotelId
          })
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.getLogUtils().logWithTag('selectedRows', selectedRows)
      this.getLogUtils().logWithTag('selectedRowKeys', this.selectedRowKeys)
    },
    onSearchChange(selectedRowKeys, selectedRows) {
      this.searchRowKeys = selectedRowKeys
      this.getLogUtils().logWithTag('searchRowKeys', selectedRows)
      this.getLogUtils().logWithTag('onSearchChange', this.searchRowKeys)
    },
    onCheckboxProps: record => ({
      props: {
        disabled: record.add === false // Column configuration not to be checked
      }
    }),
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    onSubmitData() {
      this.loading = true
      let list = [...this.selectedRowKeys, ...this.searchRowKeys]
      this.getLogUtils().logWithTag('searchRowKeys', list)
      if (list && list.length > 5) {
        this.$message.error('最多可匹配5个酒店')
        return
      }
      let params = {
        erpHotelId: this.proId,
        matchProIdList: this.selectedRowKeys,
        merchantId: this.merchantId,
        platformId: this.platformId,
        outerProIdList: this.searchRowKeys
      }
      this.getHttpServices().getCloudProService().post('erp/search/matchPlatformHotel', params).then(res => {
        this.getLogUtils().logWithTag('searchRowKeys', res)
        this.$message.success('保存成功')
        this.loading = false
        setTimeout(() => {
          this.goBack()
        }, 500)
      }).catch(reason => {
        this.loading = false
        this.showNetWorkErrorMessage(reason)
      })
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      if (params.hotelId || params.hotelName) {
        return this.getHttpServices().getCloudProService().post('erp/search/findPlatformHotelList', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    getProColumns() {
      return [
        {
          title: '产品ID ',
          dataIndex: 'hotelId'
        },
        {
          title: '产品名称',
          dataIndex: 'hotelName'
        },
        {
          title: '联系电话',
          dataIndex: 'hotelPhone'
        },
        {
          title: '地址',
          dataIndex: 'hotelAddress'
        },
        {
          title: '经纬度',
          dataIndex: 'Latitude',
          scopedSlots: { customRender: 'latSlots' }
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 10px;
}

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.title-name {
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 10px;
}

.recommend-name {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}

.ul-content {
  li {
    display: flex;
    line-height: 30px;
    align-items: center;

    .left-labei {
      width: 120px;
      text-align: right;
    }
  }
}

.search-list {
  cursor: pointer;

  .ul-box {
    margin-bottom: 15px;
    display: inline-block;

    li {
      line-height: 25px;
      padding-left: 25px;
    }
  }
}

.btns {
  padding: 28px;
}
</style>
<style lang="less">
.search-list {
  .ant-radio {
    position: absolute;
    left: 5px;
    top: 5px;
    z-index: 1200;
  }
}
</style>